import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { GlobalService } from '../../shared/services/global/global.service';
import { WhatsappCampaignService } from 'src/app/business-service/whatsapp-campaign/whatsapp-campaign.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { InputValidationsService } from '../../shared/services/validations/input-validations.service';

@Component({
  selector: 'app-whatsapp-campaign-form',
  templateUrl: './whatsapp-campaign-form.component.html',
  styleUrls: ['./whatsapp-campaign-form.component.scss'],
})
export class WhatsappCampaignFormComponent implements OnInit {

  campaignForm!: FormGroup;

  templates: any[] = [];

  constructor(
    private _modalController: ModalController,
    private _fb: FormBuilder,
    private _globalService: GlobalService,
    private _whatsappCampaignService: WhatsappCampaignService,
    private _responseNotificationService: ResponseNotificationService,
    private _inputValidationService: InputValidationsService
  ) { }

  async ngOnInit() {
    this.templates = await this.getWhatsappTemplates();

    this.campaignForm = this._fb.group({
      campaignId: [''],
      name: ['', [Validators.required]],
      templateId: ['', [Validators.required]],
      selectedContacts: [[], [this._inputValidationService.arrayNotEmptyValidator()]],
      schedule: ['scheduleNow'],
      scheduleDate: [null],
      scheduleTime: [null]
    });

    this.campaignForm.get('schedule')?.valueChanges.subscribe(value => {
      if (value === 'scheduleLater') {
        this.campaignForm.get('scheduleDate')?.setValidators([Validators.required]);
        this.campaignForm.get('scheduleTime')?.setValidators([Validators.required]);
      } else {
        this.campaignForm.get('scheduleDate')?.clearValidators();
        this.campaignForm.get('scheduleTime')?.clearValidators();
      }
      this.campaignForm.get('scheduleDate')?.updateValueAndValidity();
      this.campaignForm.get('scheduleTime')?.updateValueAndValidity();
    });
  }

  async getWhatsappTemplates(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._whatsappCampaignService.getWhatsappTemplates(-1, -1).subscribe({
        next: (res: any) => {
          resolve(res.data);
        },
        error: (err: any) => {
          reject(err);
        }
      });
    });
  }


  get today(): Date {
    let date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  }

  onSubmit() {
    if (this.campaignForm.invalid) {
      this.campaignForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Form is invalid, please fill all required fields.");
      return;
    }

    const serializedData = this.serializeFormData();
    this._whatsappCampaignService.addUpdateWhatsappCampaign(serializedData).subscribe({
      next: (res: any) => {
        this._responseNotificationService.showMessage('WhatsApp Campaign saved successfully.');
        this.closeModal();
      },
      error: (err: any) => {
        this._globalService.customAlert('Error saving WhatsApp Campaign. Please try again.');
      }
    });

  }

  serializeFormData(): any {
    const formValue = this.campaignForm.value;
    let serializedData: any = {
      ...formValue,
      // schedule: {
      //   type: formValue.schedule,
      //   dateTime: formValue.schedule === 'scheduleLater' ? this._globalService.combineDateAndTime(formValue.scheduleDate, formValue.scheduleTime) : null
      // },
      contacts: this.getSelectedContactsArray(formValue.selectedContacts)
    };

    delete serializedData.schedule;
    delete serializedData.scheduleDate;
    delete serializedData.scheduleTime;
    delete serializedData.selectedContacts;
    return serializedData;
  }

  // function to get array of objects with properties item.code+item.phoneNumber from array of selected contacts
  getSelectedContactsArray(selectedContacts: any): any[] {
    let contactsArray: any[] = [];
    selectedContacts.forEach((item: any) => {
      if (item.phoneNumber) {
        contactsArray.push({
          number: (item.phoneCountryCode || '') + item.phoneNumber,
        });
      }
    });
    return contactsArray;
  }

  closeModal() {
    this._modalController.dismiss();
  }

}
